export default "__VITE_ASSET__ee7ff23d__"